<template>
  <div style="width: 1200px; margin: 0 auto">
    <Title :title="{ name: '个人中心', path: '/user/center' }"></Title>

    <el-container>
      <el-aside style="width: 30%">
        <el-card class="box-card" style="min-height: 650px">
          <div slot="header" class="clearfix">
            <span style="font-size: 18px; font-weight: 700">个人信息</span>
          </div>
          <div style="width: 200px; margin: 0 auto">
            <img src="" width="200px" style="border-radius: 10px" />
          </div>
          <div style="font-size: 14px">
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
              "
            >
              <span class="secondary"> 用户姓名: </span>
              <span> {{ user.realName }} </span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
              "
            >
              <span class="secondary"> 所属部门: </span>
              <span> {{ user.deptName }} </span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
              "
            >
              <span class="secondary">工作岗位: </span>
              <span> {{ user.job }} </span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
              "
            >
              <span class="secondary">入职时间: </span>
              <span> {{ user.entryTime }} </span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
              "
            >
              <span class="secondary">最后登录时间: </span>
              <span> {{ user.lastLoginTime }} </span>
            </div>
          </div>
        </el-card>
      </el-aside>
      <el-main
        style="
          padding-top: 0px;
          width: 70%;
          padding-left: 20px;
          padding-right: 0px;
        "
      >
        <el-card class="box-card" style="min-height: 650px">
          <el-menu
            default-active="1"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1">用户资料</el-menu-item>
            <el-menu-item index="2">操作日志</el-menu-item>
          </el-menu>

          <el-form
            ref="account"
            :model="user"
            label-width="80px"
            style="margin-top: 30px"
            :rules="rules"
            v-if="activeIndex == 1"
          >
            <el-form-item label="姓名" prop="realName">
              <el-input
                v-model="user.realName"
                size="small"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="phone">
              <el-input
                v-model="user.phone"
                size="small"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="岗位" prop="job">
              <el-input
                v-model="user.job"
                size="small"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="生日" prop="birthDay">
              <el-date-picker
                style="width: 300px"
                value-format="yyyy-MM-dd"
                v-model="user.birthDay"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="入职日期" prop="entryTime">
              <el-date-picker
                style="width: 300px"
                value-format="yyyy-MM-dd"
                v-model="user.entryTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="user.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="onsubmit"
                >保存信息</el-button
              >
            </el-form-item>
          </el-form>
          <el-table
            v-if="activeIndex == 2"
            :data="sysLogTable"
            :header-cell-style="{
              background: 'rgb(245,245,245)',
              color: 'black',
            }"
            :cell-style="{ color: 'black' }"
            style="width: 100%"
          >
            <el-table-column
              prop="requestDesc"
              label="操作描述"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="responseCode" label="响应状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.requestCode == 200" type="success"
                  >成功</el-tag
                >
                <el-tag v-else type="danger">失败</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="操作时间">
            </el-table-column>
          </el-table>
          <div class="tabListPage" style="float: right" v-if="activeIndex == 2">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Title from "../../Title";
import { AesDecrypt, AesEncrypt } from "../../../util";
import { requestSysLogByUser, requestUpdateUserInfoById } from "../../../api";

export default {
  name: "userCenter",
  components: { Title },
  data() {
    var checkphone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
        // 引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      currentPage: 1, // 默认显示第几页
      totalCount: 0, //  // 总条数，根据接口获取数据长度(注意：这里不能为空)
      pageSizes: [8, 10, 15, 20, 30], //   // 个数选择器（可修改）
      pageSize: 8, // 默认每页显示的条数（可修改）
      activeIndex: "1",
      sysLogTable: [],
      user: {},
      rules: {
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        realName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          { max: 10, message: "昵称不能超过10个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: checkphone,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        job: [
          { required: true, message: "请输入岗位", trigger: "blur" },
          { max: 20, message: "岗位不能超过20个字符", trigger: "blur" },
        ],
        birthDay: [
          { required: true, message: "请输入生日日期", trigger: "blur" },
        ],
        entryTime: [
          { required: true, message: "请选择入职日期", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getSysLogByUser();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSysLogByUser();
    },
    handleSelect(key) {
      this.activeIndex = key;
      if (key == 2) {
        this.getSysLogByUser();
      }
    },
    onsubmit() {
      this.$refs.account.validate((ispass) => {
        if (ispass) {
          requestUpdateUserInfoById(this.user).then((res) => {
            if (res.code === 200) {
              let user = res.object.user;
              let jwt = res.object.jwt;
              window.localStorage.setItem(
                "user",
                AesEncrypt(JSON.stringify(user))
              );
              window.localStorage.setItem("jwt", jwt);
              this.$message.success("保存成功,信息下次登录生效");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    async getSysLogByUser() {
      let param = { current: this.currentPage, size: this.pageSize };
      const res = await requestSysLogByUser(param);
      if (res.code == 200) {
        this.sysLogTable = res.rows;
        this.totalCount = res.total;
      } else {
        this.$message.error("获取个人操作日志失败");
      }
    },
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
  },
};
</script>

<style scoped>
.secondary {
  color: #909399;
}

/* 按钮右对齐 */
.btns {
  display: flex;
  justify-content: flex-end;
}

/* 按钮样式重写 */
.btn_font {
  width: 100px;
  border-radius: 4px;
  color: #409eff;
}

.btn_font:hover {
  color: #ffffff;
  background-color: #409eff;
}

/* 验证码盒子 */
.code_box {
  height: 40px;
  width: 100%;
}

.code_box img {
  width: 128px;
  height: 39px;
  border: 1px solid #eee;
  border-radius: 4px;
}
</style>
